@use "@fukuri-admins/ui/layout" as *;

.statusCol {
  width: 110px;
}

.readAtCol {
  width: 160px;
}

